import React, { useState } from "react";
import {
  Stack,
  Toolbar,
  Typography,
  Container,
  AppBar,
  Button,
  Drawer,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import Menu from "@mui/icons-material/Menu";
import Close from "@mui/icons-material/Close";


const Nav = () => {
  const [open, setOpen] = useState(false);
  const toggleDrawer = newOpen => () => {
    setOpen(newOpen);
  };
  return (
    <>
      <Button
        variant="text"
        onClick={toggleDrawer(true)}
        sx={{ color: "white", display: { xs: "flex", sm: "none" } }}
      >
        <Menu />
      </Button>
      <Drawer
        open={open}
        onClose={toggleDrawer(false)}
        anchor="right"
        sx={{
          display: { xs: "inherit", sm: "none" },
          "& .MuiDrawer-paper": {
            height: "100%",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button onClick={toggleDrawer(false)}>
            <Close />
          </Button>
        </Box>
        <NavList />
      </Drawer>
      <NavList
        sx={{
          display: { xs: "none", sm: "inherit" },
        }}
      />
    </>
  );
};
const NavList = ({ ...props }) => {
  return (
    <Stack
      overflow="auto"
      direction={{ xs: "column", sm: "row" }}
      gap={3}
      width={{ xs: "100%", sm: "initial" }}
      textAlign={{ xs: "center", sm: "initial" }}
      fontSize={{ xs: "22px", sm: "initial" }}
      {...props}
    >
        <Link to="/" style={{textDecoration:"none"}}><Typography style={{color:"white"}}>Book an appointment</Typography></Link>
        <Link to="/adminappointment" style={{textDecoration:"none"}}><Typography style={{color:"white"}}>Add Appointment</Typography></Link>
        <Link to="/about" style={{textDecoration:"none"}}><Typography style={{color:"white"}}>About</Typography></Link>

    </Stack>
  );
};
const Header = () => {
  return (
    <AppBar sx={{marginBottom:"30px"}}>
      <Container>
        <Toolbar>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          > 
            <Link to="/" style={{textDecoration:"none"}}>
            <Typography variant="h3" style={{color:"white"}}>Aakaar Clinic</Typography>
            </Link>
            <Nav />
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;